export const getAssessmentParameterCheckFields = (siteProposalFieldValidation, parameterId) => {
  if (!siteProposalFieldValidation?.assessmentParameters || parameterId == null) {
    return null
  }

  return siteProposalFieldValidation.assessmentParameters[parameterId] ?? null
}

export const shouldShowAssessmentParameterFieldError = (
  siteProposalFieldValidation,
  qualified,
  checkFields,
  fieldName
) => {
  if (!siteProposalFieldValidation?.updated || !qualified || !checkFields) {
    return false
  }

  return checkFields[fieldName] === false
}
